import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { withTheme } from '@emotion/react';


const SelectInput = (props) => {

    const [initial, setDefault] = React.useState("");

    const theme = props.theme

    React.useEffect(()=> setDefault(""),[])

    return (
        <FormControl  sx={{ mt:props.mt ?? '0px', width:{xs:'100%',md:'auto'}}}  >
            <FormHelperText  sx={{...theme.typography.inputTitle, color:'#292727', mx:'0px'}} id="my-helper-text">{ props.label ?? ' '}</FormHelperText>
            <Select
              value={initial}
              sx={{
                width:{xs:'100%', md: props.inputWidth ?? '25ch'},
                marginTop:'8px',
                '& .MuiOutlinedInput-notchedOutline':{
                   borderColor: '#98A2B3',
                   borderRadius:'8px',
                   paddingLeft:'24px'
                }
             }}
                inputProps={{ 'aria-label': 'select' }}
                labelId='id="demo-simple-select-helper-label'
                id="demo-simple-select-helper"
            >
                <MenuItem  value="">
                    Select test type
                </MenuItem>
                {
                    props.options.map((opt, i)=>(
                        <MenuItem key={i} sx={{ ...theme.typography.textArea, color:'#292727'}} value={opt}>{opt}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
}
export default withTheme(SelectInput);